import { Box, Tab, Tabs } from '@material-ui/core'
import { useCallback, useState } from 'react'

import { AddFolderModal } from './add-folder-modal'
import { FoldersList } from './folder-list'
import { Header } from './header'
import { useStyles } from './styles'

export default function Folders() {
  const classes = useStyles()
  const [searchFolder, setSearchFolder] = useState('')
  const [showAddFolderModal, setShowAddFolderModal] = useState(false)

  const [actualTab, setActualTab] = useState<'byownerid' | 'byuserid'>(
    'byownerid',
  )

  const handleSearchFolder = useCallback(setSearchFolder, [])
  const handleAddFolderModal = useCallback(setShowAddFolderModal, [])

  return (
    <Box className={classes.main}>
      <Header
        searchFolder={searchFolder}
        handleSearchFolder={handleSearchFolder}
        showAddFolderModal={() => handleAddFolderModal(true)}
      />

      <Tabs
        value={actualTab}
        variant='scrollable'
        className={classes.tabs}
        onChange={(_, value) => setActualTab(value)}
      >
        <Tab
          label={'Minhas pastas'}
          key={'Minhas pastas'}
          value={'byownerid'}
        />
        <Tab
          label={'Compartilhados comigo'}
          key={'Compartilhados comigo'}
          value={'byuserid'}
        />
      </Tabs>

      <FoldersList tab={actualTab} searchFolder={searchFolder} />

      <AddFolderModal
        open={showAddFolderModal}
        onClose={() => setShowAddFolderModal(false)}
      />
    </Box>
  )
}
